export const REVIEW_NOTIFICATION_EMAILS = "REVIEW_NOTIFICATION_EMAILS";

const initialState = null;

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case REVIEW_NOTIFICATION_EMAILS:
            return action.payload;
        default:
            return state;
    }
};

const storeName = "reviewNotificationEmails";

const storeMapping = { [storeName]: reducer };

export const reviewNotificationEmailsSelector = (state) => state[storeName];

export default storeMapping; 
